<div class="star">
  <ion-row>
    <ion-col size="2" class="stars" *ngFor="let star of [].constructor(5); let i = index"
      (click)="rate=i+1; didRated.emit((i+1) * 2)">
      <ion-icon class="star-icons" color="{{rate >= (i+1)*2 ? 'primary' : 'medium'}}" name="star"></ion-icon>
    </ion-col>
  </ion-row>
</div>